import { parseNumeric } from "./contractDetailsShared.mjs";

export const mapContractFileUpload = (data, selectedFile) => ({
  stored_path: String(data?.filePath || "").trim() || null,
  upload_token: String(data?.uploadToken || "").trim() || null,
  file_name: String(data?.filename || selectedFile?.name || "").trim() || null,
  mime_type: String(data?.mimetype || selectedFile?.type || "").trim() || null,
  file_size_bytes: parseNumeric(data?.size, parseNumeric(selectedFile?.size, 0)),
});
